import { isValidElement, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { isString, isEmpty, isArray } from 'lodash';

// check if the message has already been created
const isAlreadyParsed = (message) =>
  isString(message) || isValidElement(message) || isArray(message);

/**
 * useSafeLabel
 * Same as safeLabel but uses intl.formatMessage instead
 */
const useSafeLabel = () => {
  const intl = useIntl();

  const handleSafeLabel = useCallback(
    (message, values = {}) => {
      if (isEmpty(message)) {
        return null;
      }

      // same as safe Label
      return isAlreadyParsed(message)
        ? message
        : intl.formatMessage(message, values);
    },
    [intl],
  );

  return handleSafeLabel;
};

export default useSafeLabel;
